export default __webpack_public_path__ + "static/media/calendar-icon.4e7ec88b.svg";